import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { rem } from 'polished'

import { DATEPICKER_GRID_CELL_SIZE } from '../day/styles'

export const root = css({
  margin: '0 auto',
  maxWidth: rem(320),
  width: '100%',
})

export const title = css({
  marginBottom: rem(7),
  padding: `0 ${rem(10)}`,
})

export const grid = (theme: Theme): SerializedStyles =>
  css({
    alignItems: 'center',
    display: 'grid',
    gap: `${rem(7)} 0`,
    gridAutoRows: DATEPICKER_GRID_CELL_SIZE,
    gridTemplateColumns: 'repeat(7, 1fr)',
    marginBottom: theme.spacing(4),
  })

export const dayTitle = css({
  textAlign: 'center',
})
